import styled from '@emotion/styled';
import { breakpoints } from '~/theme';
import { scrollbarThin } from '~/shared/utils/styled';

export const StyledMobileCategories = styled.div(({ theme }) => ({
    display: 'flex',
    gap: theme.spaces[2],
    marginTop: theme.spaces[2],
    flexWrap: 'nowrap',
    overflowX: 'scroll',
    width: `calc(100% + ${theme.gridConfig.gutter})`,
    paddingRight: theme.gridConfig.gutter,
    paddingBottom: theme.spaces[2],
    ...scrollbarThin,
    [breakpoints.md]: {
        display: 'none',
    },
}));
